import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react'
import { Description } from 'components/Typography'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getCategories } from 'reducks/category/selectors'
import { fetchCategories, saveCategories } from 'reducks/category/operations'
import { CategoryType } from 'types/category'
import { CategoryCard } from 'components/Card'
import { NavButton, OrangeButton } from 'components/Button'
import { push } from 'connected-react-router'

const CategoriesTemplate: FC = () => {
  const dispatch = useDispatch()
  const categories = useSelector((state: State) => getCategories(state))

  const [categoryList, setCategoryList] = useState<CategoryType[]>([])

  const handleCategoryName = useCallback(
    (event: ChangeEvent<HTMLInputElement>, id: string) => {
      setCategoryList((prevState) => {
        const index = prevState.findIndex((category) => category.category_ref.id === id)
        if (index === -1) return prevState
        const nextState = prevState
        nextState[index].name = event.target.value
        return [...nextState]
      })
    },
    [setCategoryList]
  )

  const selectCategoryDisabled = useCallback(
    (value: string, id: string) => {
      setCategoryList((prevState) => {
        const index = prevState.findIndex((category) => category.category_ref.id === id)
        if (index === -1) return prevState
        const nextState = prevState
        nextState[index].is_disabled = value === 'disabled'
        return [...nextState]
      })
    },
    [setCategoryList]
  )

  useEffect(() => {
    dispatch(fetchCategories())
  }, [])

  useEffect(() => {
    if (!categories) return
    setCategoryList([...categories])
  }, [categories])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <Description description={'パン用のカテゴリをここから編集できます。'} />
      <Spacer size={28} />
      {categoryList.map((category) => (
        <React.Fragment key={category.category_ref.id}>
          <CategoryCard
            name={category.name}
            status={category.is_disabled ? 'disabled' : 'enabled'}
            handleCategoryName={(e) => handleCategoryName(e, category.category_ref.id)}
            selectCategoryDisabled={(value) => selectCategoryDisabled(value, category.category_ref.id)}
          />
          <Spacer size={12} />
        </React.Fragment>
      ))}
      <Spacer size={48} />
      <OrangeButton
        label={'保存する'}
        onClick={() => dispatch(saveCategories(categoryList))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <NavButton
        label={'トップページに戻る'}
        iconPath={'/icon/grey/home.svg'}
        onClick={() => dispatch(push('/admin/shops'))}
        url={''}
      />
      <Spacer size={72} />
    </div>
  )
}

export default CategoriesTemplate
